/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import AppStorage from '@app/lib/AppStorage';

const SCHEDULED_MAINTENANCE_DISMISS_KEY_PREFIX = 'fluxer_scheduled_maintenance_dismissed:';

function getDismissKey(maintenanceId: string): string {
	return `${SCHEDULED_MAINTENANCE_DISMISS_KEY_PREFIX}${maintenanceId}`;
}

export function isScheduledMaintenanceNagbarDismissed(maintenanceId: string | null | undefined): boolean {
	if (!maintenanceId) {
		return false;
	}

	return AppStorage.getItem(getDismissKey(maintenanceId)) === '1';
}

export function dismissScheduledMaintenanceNagbar(maintenanceId: string): void {
	AppStorage.setItem(getDismissKey(maintenanceId), '1');
}
